
/* eslint-disable no-return-await */
import Util from '@/assets/libs/util'
import requesModule from '@/assets/libs/requestModule'
import CartController from '@/assets/controllers/CartController'
import PrinterController from '@/assets/controllers/PrinterController'
import PaymentController from '@/assets/controllers/PaymentController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import LocaleController from '@/assets/controllers/LocaleController'
import CashbackCampaingController from './CashbackCampaingController'
import eventModule from '@/assets/libs/eventModule'
import waitForDOMUpdate from '@/assets/libs/waitForDOMUpdate'

// const EVENT_SAVE_ORDER = 'sale/saveDeliverySale' // rota padrao da Odhen Interface
const EVENT_SAVE_ORDER = 'v3/sale/saveDeliverySaleEx' // rota criada para o novo TAA (retorna o pagerID randômico e aplica regra de imprime sim/não)
const EVENT_CLOSE_ORDER = 'sale/closeOrder'
const EVENT_GET_SALE = 'sale/getSale'
const EVENT_CANCEL_ORDER = 'sale/cancelOrder'
const EVENT_CANCEL_PAYMENT = 'sale/cancelPayments'
const EVENT_CANCEL_SALE = 'sale/cancelSale'
const EVENT_SAVE_PAYMENT = 'sale/savePayment'
const EVENT_CLEAR_COMANDA = 'sale/cleanOrder'
const EVENT_EDIT_SERVICE_TAX = 'sale/editServiceTax'
const EVENT_REGISTER_PAGER = 'sale/registerDigitalPager'
const EVENT_FINSH_ORDER = 'sale/finishOrder'
const EVENT_ADD_PORDUCTS_COMANDA = 'sale/saveOrder'
const EVENT_PRINT_CANCEL = 'sale/printCancel'
const EVENT_GET_STATUS_TABLE = 'sale/getStatusTable'

let preOrderDate = ''
let closeOrderByService = !Util.isOracle()
let saleInfo = null
let address = null

const buildSaleData = (paymentNumber, authHash, paymentMethod, cart, orderCPF = '', complementedPayment = false) => {
    let isBalancaMode = Util.isBalancaMode()
    let orderData = {}
    let dataObject = {
        taaSaleId: '', // Hash pra identificação (opcional)
        order: orderData // dados da venda
    }

    // Dados gerais da venda
    if (paymentMethod.IDTIPORECE === '4' || Util.isTapMode()) {
        orderData.closeByApi = false
    } else {
        orderData.closeByApi = true
    }
    orderData.subsidiaryCode = Util.getGeneralInfo()['subsidiaryCode']
    orderData.storeCode = Util.getGeneralInfo()['storeCode']
    orderData.posCode = Util.getGeneralInfo()['posCode']
    orderData.pagerId = CartController.getPagerCode() !== null ? CartController.getPagerCode() : ''
    orderData.clientCode = ''
    orderData.consumerCode = ''
    orderData.consumerId = ''
    orderData.consumerName = CartController.getConsumerName()
    orderData.items = []

    let consumerDataFidelity = CashbackCampaingController.getConsumerData()

    if (consumerDataFidelity && consumerDataFidelity.consumerData && consumerDataFidelity.consumerData.clientCode) {
        orderData.clientCode = consumerDataFidelity.consumerData.clientCode
        orderData.consumerCode = consumerDataFidelity.consumerData.consumerCode
        orderData.consumerId = consumerDataFidelity.consumerData.consumerId
    }

    let userIsLogged = IdentifiedConsumerController.userIsLogged()

    if (userIsLogged) {
        let consumerData = IdentifiedConsumerController.getConsumerData()
        orderData.clientCode = consumerData.clientCode
        orderData.consumerCode = consumerData.consumerCode
        orderData.consumerId = consumerData.consumerId
    }

    // Detalhes da venda
    orderData.orderDescription = {}

    if (address) {
        orderData.orderDescription.recipient = {
            fullName: address.fantasia || '',
            stateRegistration: address.registroEstado || '',
            address: {
                zipCode: address.cep || '',
                street: address.rua || '',
                number: address.numero || '',
                complement: address.complemento || '',
                neighborhood: address.bairro || '',
                city: address.cidade || '',
                state: address.estado || ''
            }
        }
    }

    let modoentrega = Util.getLocalVar('modoentrega')
    let toTravel = modoentrega === 'levar'
    let driveThru = modoentrega === 'drive'

    orderData.orderDescription.phoneCRM = CashbackCampaingController.getPhone()
    orderData.orderDescription.toTravel = toTravel
    orderData.orderDescription.driveThru = driveThru
    // orderData.orderDescription.orderType = modoentrega === 'drive' ? 'DRV' : 'TAA'
    orderData.orderDescription.orderType = 'TAA'
    orderData.orderDescription.preOrderDate = preOrderDate

    let totalPrice
    // se houver desconto por valor, deixamos o parametro como verdadeiro para
    // que o valor total seja calculado com base no preço dos produtos, e não no subtotal
    let totalPriceStr = CartController.calculateTotalPrice(false, CartController.getTotalSubgroupDiscount() > 0)
    let discount = CashbackCampaingController.getDiscountApplied()
    let discountCRM = discount.value
    totalPriceStr = totalPriceStr.replace('R$', '').replace(',', '').replace('.', '').trim()
    totalPrice = parseFloat(totalPriceStr) / 100

    orderData.orderDescription.productsValue = totalPrice
    orderData.orderDescription.deliveryFee = 0
    orderData.orderDescription.totalValue = orderData.orderDescription.productsValue + orderData.orderDescription.deliveryFee
    orderData.orderDescription.changeValue = 0
    orderData.orderDescription.serviceTax = 0
    orderData.orderDescription.giftCards = []
    orderData.orderDescription.deliveryAddress = null
    orderData.orderDescription.isScheduled = false
    orderData.orderDescription.scheduledDate = ''
    orderData.orderDescription.orderCPF = ''

    if (orderCPF !== '') {
    // A regex retira da string tudo que nao sejam numeros
        orderCPF = orderCPF.replace(/[.\-/\s]+/g, '').toUpperCase()
        orderData.orderDescription.orderCPF = orderCPF
    }

    if (discount.value) {
        orderData.orderDescription.discountCRM = discount.campaignEnabled === 1 ? discountCRM : 0
        orderData.orderDescription.orderDiscount = discount.campaignEnabled === 2 ? discountCRM : 0
        orderData.orderDescription.gcomDiscount = discount.campaignEnabled === 3 ? discountCRM : 0
        if (discount.campaignEnabled === 4) {
            /* Olga Tech */
            let giftApplied = CashbackCampaingController.getGiftApplied()
            if (giftApplied && giftApplied.length > 0) {
                let olgaTech = {
                    couponId: giftApplied[0].id,
                    benefitId: giftApplied[0].gift.type === 'CASHBACK' ? 'C' : 'D',
                    isCashback: giftApplied[0].is_cashback === true || giftApplied[0].is_cashback === 'true',
                    type: giftApplied[0].type,
                    customer_doc: giftApplied[0].gift.customer_doc,
                    customerPhone: CashbackCampaingController.getPhone(),
                    orderAmount: parseFloat(discount.value).toFixed(2) || 0, // valor do desconto ou do cupom
                    obs: ''
                }
                orderData.orderDescription.olgaTech = olgaTech
            }
        }
    }

    if (discount.campaignEnabled === 5) {
        let fixeCrmConfig = Util.getLocalConfigs('fixeCrm')
        if (fixeCrmConfig && fixeCrmConfig.url) {
            orderData.orderDescription.fixeCrm = {
                cpf: orderCPF || '',
                redemptionValue: parseFloat(discountCRM) || 0
            }
        }
    }
    // Trata do pagamento para esta venda
    if (paymentMethod.IDTIPORECE === '4') {
        orderData.orderDescription.payments = []
    } else {
        let digitalWalletName = CartController.getDigitalWalletName()
        if (complementedPayment) {
            orderData.orderDescription.payments = []
            let compPaymentData = IdentifiedConsumerController.getCompPaymentData()
            let discoutPrincipalPayment = Math.round(((parseFloat(totalPrice) - parseFloat(discountCRM)) - parseFloat(compPaymentData.compValue)) * 100) / 100
            let principalPayment = {
                paymentCode: generatePaymentCode(paymentMethod),
                paymentName: '',
                value: discoutPrincipalPayment > 0 ? discoutPrincipalPayment : Math.round((parseFloat(totalPrice) - parseFloat(compPaymentData.compValue)) * 100) / 100,
                nsu: paymentNumber,
                // No caso de pagamento complementado, o principalPayment sempre é crédito pessoal ou débito consumidor.
                // O digitalWalletName que chega aqui, se chegar, é referente apenas ao complementaryPayment
                digitalWallet: null,
                authHash: authHash
            }

            let complementaryPayment = {
                paymentCode: generatePaymentCode(compPaymentData.compPaymentMethod),
                paymentName: '',
                value: discoutPrincipalPayment <= 0 ? Math.round((compPaymentData.compValue - discountCRM) * 100) / 100 : Math.round((compPaymentData.compValue) * 100) / 100,
                nsu: compPaymentData.NSU,
                authHash: compPaymentData.authHash,
                digitalWallet: digitalWalletName || null
            }

            orderData.orderDescription.payments.push(principalPayment)
            orderData.orderDescription.payments.push(complementaryPayment)
        } else {
            orderData.orderDescription.payments = [{
                paymentCode: generatePaymentCode(paymentMethod),
                paymentName: '',
                value: totalPrice - discountCRM,
                nsu: paymentNumber,
                digitalWallet: digitalWalletName || null,
                authHash: authHash
            }]
        }

        let identifiedConsumerMethod = paymentMethod.IDTIPORECE === '9' || paymentMethod.IDTIPORECE === 'A'

        if (identifiedConsumerMethod) {
            let consumerData = IdentifiedConsumerController.getConsumerData()
            orderData.orderDescription.payments[0].clientCode = consumerData.clientCode
            orderData.orderDescription.payments[0].consumerCode = consumerData.consumerCode
        }
    }
    /* End Olga Tech */
    // Monta os itens da venda, de acordo com o Carrinho
    cart.forEach(product => {
        let current = {}
        current.productName = product.productName
        current.productCode = product.productCode
        current.productPrint = product.productPrint
        current.quantity = (isBalancaMode || product.insertedByEan13) ? product.quantity : 1
        current.unitValue = product.price
        current.discount = 0
        current.toTravel = toTravel
        current.note = product.typedObs || ''
        current.observations = []
        current.childItems = []
        current.sequence = product.sequence || ''
        // Trata as observacoes para este produto (produto pai ou item simples)
        product.observations.forEach(observation => {
            if (observation.quantity === undefined) {
                observation.quantity = 1
            }
            current.observations.push(observation)
        })

        // Trata os itens filhos deste produto (quando for combo)
        product.productCombo.forEach(childItem => {
            let newChild = {
                productGroupCode: childItem.productGroupCode || null,
                productCode: childItem.subItemCode,
                productName: childItem.subItemName,
                productPrint: childItem.subItemProductPrint,
                groupPrint: childItem.groupPrint,
                unitValue: childItem.price,
                toTravel: toTravel,
                quantity: 1,
                discount: 0,
                note: childItem.typedObs || '',
                observations: [],
                sequence: childItem.sequence || ''
            }

            // Trata as observacoes dos itens filhos (quando for combo)
            if (childItem && childItem.observations) {
                childItem.observations.forEach(obs => {
                    let newObs = {
                        obsGroupCode: obs.subItemObsGroupCode,
                        obsCode: obs.subItemObsCode,
                        obsName: obs.subItemObsName,
                        price: obs.price || 0,
                        quantity: obs.quantity || 1,
                        obsType: obs.subItemObsType,
                        obsProductCode: obs.subItemObsProductCode
                    }
                    newChild.observations.push(newObs)
                })
            }

            // Trata os itens filhos de filhos quando for combo do combo
            if (childItem.choosen) {
                newChild.childItems = []
                let keys = Object.keys(childItem.choosen)
                keys.forEach(key => {
                    childItem.choosen[key].forEach(subSubProd => {
                        let newInnerChild = {
                            productGroupCode: subSubProd.subProductGroupCode || null,
                            productCode: subSubProd.subItemCode,
                            productName: subSubProd.subItemName,
                            productPrint: subSubProd.groupPrint,
                            unitValue: subSubProd.price,
                            toTravel: toTravel,
                            quantity: 1,
                            discount: 0,
                            note: subSubProd.typedObs || '',
                            observations: [],
                            sequence: subSubProd.sequence || ''
                        }

                        // Trata as observacoes dos itens filhos de filhos (quando for combo do combo)
                        if (subSubProd && subSubProd.observations) {
                            subSubProd.observations.forEach(obs => {
                                let newObs = {
                                    obsGroupCode: obs.subItemObsGroupCode,
                                    obsCode: obs.subItemObsCode,
                                    obsName: obs.subItemObsName,
                                    price: obs.price || 0,
                                    quantity: obs.quantity || 1,
                                    obsType: obs.subItemObsType,
                                    obsProductCode: obs.subItemObsProductCode
                                }
                                newInnerChild.observations.push(newObs)
                            })
                        }
                        let subQuantity = subSubProd.quantity ? subSubProd.quantity : 1
                        for (let i = 0; i < subQuantity; i++) {
                            newChild.childItems.push(newInnerChild)
                        }
                    })
                })
            }
            let quantity = childItem.quantity ? childItem.quantity : 1
            for (let i = 0; i < quantity; i++) {
                current.childItems.push(newChild)
            }
        })
        if (isBalancaMode || product.insertedByEan13) {
            orderData.items.push(current)
        } else if (product && product.productCombo.length > 0) {
            let fatherQuantity = product.quantity ? product.quantity : 1
            for (let i = 0; i < fatherQuantity; i++) {
                orderData.items.push(current)
            }
        } else {
            current.quantity = product.quantity || 1
            orderData.items.push(current)
        }
    })
    return dataObject
}
const buildProductsData = (products, comanda) => {
    // let tableInfo = Util.getLocalVar('tableInfo')
    let isBalancaMode = false // Util.isBalancaMode()
    let orderData = {}
    let dataObject = {
        taaSaleId: '', // Hash pra identificação (opcional)
        order: orderData // dados da venda
    }

    // Dados gerais da venda
    orderData.closeByApi = false
    orderData.subsidiaryCode = Util.getGeneralInfo()['subsidiaryCode']
    orderData.storeCode = Util.getGeneralInfo()['storeCode']
    orderData.posCode = Util.getGeneralInfo()['posCode']
    // orderData.pagerId = CartController.getPagerCode() !== null ? CartController.getPagerCode() : ''
    const consumer = (comanda.consumers && comanda.consumers[0]) ? comanda.consumers[0] : {}

    orderData.clientCode = consumer.clientCode || ''
    orderData.consumerCode = consumer.consumerCode || ''
    orderData.consumerId = consumer.consumerId || ''
    orderData.tableNumber = comanda.tableNumber || ''
    orderData.sellerCode = comanda.sellerCode || ''
    orderData.orderId = comanda.saleDescription || ''
    orderData.saleCode = comanda.saleCode || ''
    orderData.items = []

    // Detalhes da venda
    orderData.orderDescription = {}

    let toTravel = false
    let driveThru = false

    orderData.orderDescription.toTravel = toTravel
    orderData.orderDescription.driveThru = driveThru
    // orderData.orderDescription.orderType = modoentrega === 'drive' ? 'DRV' : 'TAA'
    orderData.orderDescription.orderType = 'CMD'

    let totalPrice
    let totalPriceStr = CartController.calculateTotalPrice()
    totalPriceStr = totalPriceStr.replace('R$', '').replace(',', '').replace('.', '').trim()
    totalPrice = parseFloat(totalPriceStr) / 100

    orderData.orderDescription.productsValue = totalPrice
    orderData.orderDescription.deliveryFee = 0
    orderData.orderDescription.totalValue = Util.safeDecimalCalc(calculateSubTotal(products), parseFloat(comanda.serviceTax), '+')
    orderData.orderDescription.changeValue = 0
    orderData.orderDescription.serviceTax = 0 // comanda.serviceTax
    orderData.orderDescription.giftCards = []
    orderData.orderDescription.deliveryAddress = null
    orderData.orderDescription.isScheduled = false
    orderData.orderDescription.scheduledDate = ''
    orderData.orderDescription.orderCPF = ''
    let orderCPF = ''
    if (orderCPF !== '') {
        // A regex retira da string tudo que nao sejam numeros
        orderCPF = orderCPF.replace(/\D/g, '')
        orderData.orderDescription.orderCPF = orderCPF
    }
    orderData.orderDescription.payments = []
    // Monta os itens da venda, de acordo com o Carrinho
    products.forEach(product => {
        let current = {}
        current.productName = product.productName
        current.productCode = product.productCode
        current.productPrint = product.productPrint || 'S'
        current.quantity = isBalancaMode ? product.quantity : 1
        current.unitValue = product.price
        current.discount = 0
        current.toTravel = toTravel
        current.note = product.typedObs || ''
        current.observations = []
        current.childItems = []

        // Trata as observacoes para este produto (produto pai ou item simples)
        /*  product.observations.forEach(observation => {
            if (observation.quantity === undefined) {
                observation.quantity = 1
            }
            current.observations.push(observation)
        }) */

        // Trata os itens filhos deste produto (quando for combo)
        /* product.productCombo.forEach(childItem => {
            let newChild = {
                productCode: childItem.subItemCode,
                productName: childItem.subItemName,
                productPrint: childItem.subItemProductPrint,
                groupPrint: childItem.groupPrint,
                unitValue: childItem.price,
                toTravel: toTravel,
                quantity: 1,
                discount: 0,
                note: childItem.typedObs || '',
                observations: []
            }

            // Trata as observacoes dos itens filhos (quando for combo)
            if (childItem && childItem.observations) {
                childItem.observations.forEach(obs => {
                    let newObs = {
                        obsGroupCode: obs.subItemObsGroupCode,
                        obsCode: obs.subItemObsCode,
                        obsName: obs.subItemObsName,
                        price: obs.price || 0,
                        quantity: obs.quantity || 1,
                        obsType: obs.subItemObsType,
                        obsProductCode: obs.subItemObsProductCode
                    }
                    newChild.observations.push(newObs)
                })
            }

            // Trata os itens filhos de filhos quando for combo do combo
            if (childItem.choosen) {
                newChild.childItems = []
                let keys = Object.keys(childItem.choosen)
                keys.forEach(key => {
                    childItem.choosen[key].forEach(subSubProd => {
                        let newInnerChild = {
                            productCode: subSubProd.subItemCode,
                            productName: subSubProd.subItemName,
                            productPrint: subSubProd.groupPrint,
                            unitValue: subSubProd.price,
                            toTravel: toTravel,
                            quantity: 1,
                            discount: 0,
                            note: subSubProd.typedObs || '',
                            observations: []
                        }

                        // Trata as observacoes dos itens filhos de filhos (quando for combo do combo)
                        if (subSubProd && subSubProd.observations) {
                            subSubProd.observations.forEach(obs => {
                                let newObs = {
                                    obsGroupCode: obs.subItemObsGroupCode,
                                    obsCode: obs.subItemObsCode,
                                    obsName: obs.subItemObsName,
                                    price: obs.price || 0,
                                    quantity: obs.quantity || 1,
                                    obsType: obs.subItemObsType,
                                    obsProductCode: obs.subItemObsProductCode
                                }
                                newInnerChild.observations.push(newObs)
                            })
                        }
                        let subQuantity = subSubProd.quantity ? subSubProd.quantity : 1
                        for (let i = 0; i < subQuantity; i++) {
                            newChild.childItems.push(newInnerChild)
                        }
                    })
                })
            }
            let quantity = childItem.quantity ? childItem.quantity : 1
            for (let i = 0; i < quantity; i++) {
                current.childItems.push(newChild)
            }

        }) */

        if (isBalancaMode || product.insertedByEan13) {
            orderData.items.push(current)
        } else if (product && product.productCombo && product.productCombo.length > 0) {
            let fatherQuantity = product.quantity ? product.quantity : 1
            for (let i = 0; i < fatherQuantity; i++) {
                orderData.items.push(current)
            }
        } else {
            current.quantity = product.quantity || 1
            orderData.items.push(current)
        }
    })
    return dataObject
}
const calculateSubTotal = function (products) {
    let subTotal = 0
    products.forEach(product => {
        subTotal += ((product.price * product.quantity * 100) / 100)
    })
    return subTotal
}
// Gera o código do pagamento de adordo com a bandeira do cartão usado
function generatePaymentCode (paymentMethod) {
    if (['9', 'A'].includes(paymentMethod.IDTIPORECE)) {
        return paymentMethod.CDTIPORECE
    }
    let paymentCode = null
    let bandeiraCartao = CartController.getbandeiraCartao()
    let tiposRecebimento = Util.getLocalConfigs('tiposRecebimento')

    let usedPaymentMethod = (tiposRecebimento || []).find(element => element.CDBANCARTCR != null &&
        element.CDBANCARTCR === bandeiraCartao &&
        element.CDTIPORECE === paymentMethod.CDTIPORECE
    )

    if (usedPaymentMethod === undefined) {
        usedPaymentMethod = (tiposRecebimento || []).find(element => element.CDBANCARTCR != null && element.CDBANCARTCR === bandeiraCartao)
    }

    if (usedPaymentMethod !== undefined) {
        paymentCode = usedPaymentMethod.CDTIPORECE
    } else {
        paymentCode = paymentMethod.CDTIPORECE
    }
    return paymentCode
}

function delay (seconds) {
    return new Promise(function (resolve) {
        setTimeout(resolve, seconds * 1000)
    })
}

const saveOrder = async (paymentNumber, authHash, paymentMethod, cart, orderCPF, complementedPayment) => {
    return await requesModule.postRequest(EVENT_SAVE_ORDER,
        buildSaleData(paymentNumber, authHash, paymentMethod, cart, orderCPF, complementedPayment),
        'parent').then(r => r)
}

const addPtoductsToComanda = async function (products, comanda) {
    return await requesModule.postRequest(EVENT_ADD_PORDUCTS_COMANDA,
        buildProductsData(products, comanda),
        'parent').then(r => r)
}

const closeOrder = async (saleCode) => {
    let payload = {
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        saleCode: saleCode,
        posCode: Util.getGeneralInfo()['posCode'],
        closeOrderByService: closeOrderByService
    }
    if (Util.isTapMode()) {
        payload.checkCloseByApi = false
    }
    return await requesModule.postRequest(EVENT_CLOSE_ORDER,
        payload,
        'parent').then(r => r)
}

const getSale = async (saleCode) => {
    return await requesModule.postRequest(EVENT_GET_SALE,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            saleCode: saleCode,
            posCode: Util.getGeneralInfo()['posCode'],
            closeOrderByService: closeOrderByService
        },
        'parent').then(r => r)
}

const finishOrder = async (data) => {
    return await requesModule.postRequest(EVENT_FINSH_ORDER,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            posCode: Util.getGeneralInfo()['posCode'],
            closeOrderByService: closeOrderByService,
            ...data
        },
        'parent').then(r => r)
}

const cancelOrder = async (saleCode) => {
    const payload = {
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        saleCode: saleCode,
        posCode: Util.getGeneralInfo()['posCode']
    }
    const result = await requesModule.postRequest(EVENT_CANCEL_ORDER, payload, 'parent').then(r => r)
    if (result && !result.error) {
        await requesModule.postRequest(EVENT_PRINT_CANCEL, payload).then(r => r)
    }
    return result
}

const cancelSale = async (nfceCode, saleCode) => {
    let payload = {
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        posCode: Util.getGeneralInfo()['posCode'],
        saleSeq: null
    }

    if (nfceCode != null) {
        payload.nfceCode = nfceCode
    } else {
        payload.saleCode = saleCode
    }

    return await requesModule.postRequest(EVENT_CANCEL_SALE, payload, 'parent').then(r => r)
}

const savePaymentsTAP = async (saleCode, paymentMethod, payments, orderCPF = null) => {
    let personalCreditPayment = paymentMethod.IDTIPORECE === '9' || paymentMethod.IDTIPORECE === 'A'
    if (orderCPF === '') orderCPF = null
    let campaignEnabled = CashbackCampaingController.getDiscountApplied().campaignEnabled
    let discount = CashbackCampaingController.getDiscountApplied().value
    let data = {
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        saleCode: saleCode,
        giftCard: [],
        cashBack: 0,
        payments: payments,
        orderCPF: orderCPF,
        phoneCRM: CashbackCampaingController.getPhone(),
        discountCRM: discount && campaignEnabled === 1 ? discount : 0,
        orderDiscount: discount && campaignEnabled === 2 ? discount : 0,
        gcomDiscount: discount && campaignEnabled === 3 ? discount : 0
    }
    if (campaignEnabled === 4) {
        /* Olga Tech */
        let giftApplied = CashbackCampaingController.getGiftApplied()
        if (giftApplied && giftApplied.length > 0) {
            let olgaTech = {
                couponId: giftApplied[0].id,
                benefitId: giftApplied[0].gift.type === 'CASHBACK' ? 'C' : 'D',
                isCashback: giftApplied[0].is_cashback === true || giftApplied[0].is_cashback === 'true',
                type: giftApplied[0].type,
                customer_doc: giftApplied[0].gift.customer_doc,
                customerPhone: CashbackCampaingController.getPhone(),
                orderAmount: parseFloat(discount).toFixed(2) || 0, // valor do desconto ou do cupom
                obs: ''
            }
            data.olgaTech = olgaTech
        }
        /* End Olga Tech */
    }
    if (campaignEnabled === 5) {
        let fixeCrmConfig = Util.getLocalConfigs('fixeCrm')
        if (fixeCrmConfig && fixeCrmConfig.url) {
            let cpf = null
            if (orderCPF !== '') {
                orderCPF = orderCPF.replace(/\D/g, '')
                cpf = orderCPF
            }
            data.fixeCrm = {
                cpf: cpf || '',
                redemptionValue: parseFloat(discount) || 0
            }
        }
    }
    if (personalCreditPayment) {
        let consumerData = IdentifiedConsumerController.getConsumerData()
        data.payments[0].clientCode = consumerData.clientCode
        data.payments[0].consumerCode = consumerData.consumerCode
    }

    return await requesModule.postRequest(EVENT_SAVE_PAYMENT, data).then(r => r)
}

const cancelPaymentsTAP = async (saleCode) => {
    return await requesModule.postRequest(EVENT_CANCEL_PAYMENT,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            saleCode: saleCode
        },
        'parent').then(r => r)
}

const clearComanda = async (saleCode) => {
    return await requesModule.postRequest(EVENT_CLEAR_COMANDA,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            saleCode: saleCode
        },
        'parent').then(r => r)
}

const editServiceTax = async (saleCode, serviceTax) => {
    return await requesModule.postRequest(EVENT_EDIT_SERVICE_TAX,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            saleCode: saleCode,
            serviceTax: serviceTax
        },
        'parent').then(r => r)
}

const trataNotaFiscalNaoRecebida = () => {
    Util.showInfoModal(LocaleController.getString('nao_foi_possivel_receber_XML'))
    if (Util.isTapMode()) {
        // Chamar o novo endpoint que será criado para a interface limpar a MOVCAIXA_DLV
        // Quando adicionar o endpoint, essa função terá que virar async e adicionar um await
        // na chamada do endpoint e em todas as chamadas dessa função
    }
}

const doPersonalCreditSale = async (paymentMethod, orderCPF, router, complementedPayment, isTransire = false) => {
    let cart = CartController.getCart()
    let xml = '' // Recebe o XML da Receita
    let saleData = {} // Recebe os dados da venda da Odhen Interface

    let saveOrderResponse = null
    let maxTries = 3
    let tries = 1
    let success = false
    let saleCode = null
    let saveOrderErrorMessage = null
    let paymentNumber = ''
    let authHash = ''
    let paymentOK = false
    let savePaymentsError = false
    if (Util.isTapMode()) {
        saveOrderResponse = CartController.getMainComandaAgregada()
        let totalPriceStr = CartController.calculateTotalPrice()
        totalPriceStr = totalPriceStr.replace('R$', '').replace(',', '').replace('.', '').trim()
        let totalPrice = parseFloat(totalPriceStr) / 100

        let serviceTax = saveOrderResponse.serviceTax
        if (saveOrderResponse.serviceTax !== null) {
            await editServiceTax(saveOrderResponse.saleCode, serviceTax)
        }

        let paymentsArray = []
        let digitalWalletName = CartController.getDigitalWalletName()

        if (complementedPayment) {
            let compPaymentData = IdentifiedConsumerController.getCompPaymentData()
            let principalPayment = {
                paymentCode: generatePaymentCode(paymentMethod),
                paymentName: '',
                value: Math.round((parseFloat(totalPrice) - parseFloat(compPaymentData.compValue)) * 100) / 100,
                nsu: paymentNumber,
                authHash: authHash,
                // No caso de pagamento complementado, o principalPayment sempre é crédito pessoal ou débito consumidor.
                // O digitalWalletName que chega aqui, se chegar, é referente apenas ao complementaryPayment
                digitalWallet: null
            }
            let complementaryPayment = {
                paymentCode: generatePaymentCode(compPaymentData.compPaymentMethod),
                paymentName: '',
                value: Math.round(compPaymentData.compValue * 100) / 100,
                nsu: compPaymentData.NSU,
                authHash: compPaymentData.authHash,
                digitalWallet: digitalWalletName || null
            }
            paymentsArray.push(principalPayment)
            paymentsArray.push(complementaryPayment)
        } else {
            paymentsArray = [{
                paymentCode: generatePaymentCode(paymentMethod),
                paymentName: '',
                value: totalPrice,
                nsu: paymentNumber,
                authHash: authHash,
                digitalWallet: digitalWalletName || null
            }]
        }

        let savePaymentsResponse = await savePaymentsTAP(saveOrderResponse.saleCode, paymentMethod, paymentsArray, orderCPF)
        if (!savePaymentsResponse || (savePaymentsResponse && savePaymentsResponse.error)) {
            savePaymentsError = true
            let message = {
                text: savePaymentsResponse.error ? savePaymentsResponse.message : LocaleController.getString('nao_foi_possivel_completar_venda'),
                bold: false
            }
            eventModule.$emit('setSaleMessage', message)
            Util.showInfoModal(message.text)
        }
    } else {
        do {
            try {
                saveOrderResponse = await saveOrder(paymentNumber, authHash, paymentMethod, cart, orderCPF, complementedPayment)
            } catch (error) {
                let message = 'Erro ao salvar a venda na Odhen Interface'
                console.log(message)
                console.log(error)
                if (error.error) {
                    saveOrderErrorMessage = error.message
                }
                Util.logComunication('Exception ', {}, message)
            }

            if (saveOrderResponse !== null && !saveOrderResponse.error) {
                success = true
            } else {
                tries++
            }
        } while (tries <= maxTries && !success)

        if (!success && saveOrderErrorMessage) {
            Util.showInfoModal(saveOrderErrorMessage)
        }
    }
    if (saveOrderResponse !== null && !savePaymentsError) {
        // Se a ordem e os pagamentos foram salvos corretamente, solicita à Odhen Interface o fechamento da comanda
        if (isValidResponse(saveOrderResponse)) {
            saveOrderResponse = saveOrderResponse.data ? saveOrderResponse.data[0] : saveOrderResponse
            CartController.setPagerCode(saveOrderResponse.pagerId)

            saleCode = saveOrderResponse.saleCode
            let closeOrderResponse = await closeOrder(saleCode)
            let orderAlreadyClosed = null
            let orderAlreadyFinsh = false
            let resultFinshOrder = null

            if (closeOrderByService) {
                orderAlreadyClosed = closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === true
                orderAlreadyFinsh = true
            } else {
                orderAlreadyClosed = !closeOrderResponse.error && closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === 'S'
                if (orderAlreadyClosed) {
                    resultFinshOrder = await finishOrder(closeOrderResponse.data)
                    if (resultFinshOrder && !resultFinshOrder.error) orderAlreadyFinsh = true
                }
            }
            // Se o pedido de fechamento nao retornou erro, aguarda até que o fechamento seja finalizado e o XML
            // da nota fiscal seja recebido
            //  let orderAlreadyClosed = closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === true
            if ((!closeOrderResponse.error || orderAlreadyClosed) && orderAlreadyFinsh) {
                let getSaleResponse
                let numberOfTries = 0
                const maxTries = 120
                eventModule.$emit('setSaleMessage', { text: LocaleController.getString('aguardando_cupom'), bold: false })
                do {
                    await delay(1)
                    getSaleResponse = null
                    try {
                        if (numberOfTries % 2 === 0) {
                            getSaleResponse = await getSale(saleCode)
                        }
                    } catch (error) {
                        getSaleResponse = { error: true, message: (error && error.message) || error.toString() }
                        console.log(getSaleResponse)
                    }
                    numberOfTries++
                    if (numberOfTries > 20) {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('demora_aguarde') + ' \n' + (maxTries - numberOfTries), bold: true})
                    }

                    if (getSaleResponse && getSaleResponse.error && numberOfTries === maxTries) {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('falha_cupom'), bold: false})
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                        Util.showInfoModal(getSaleResponse.message)
                    }
                } while (
                    (getSaleResponse && getSaleResponse.data && getSaleResponse.data.length === 0 && numberOfTries < maxTries && getSaleResponse.error !== true) ||
                    (getSaleResponse == null && numberOfTries < maxTries)
                )
                // Se saiu do do-while porque recebeu a resposta esperada, continua a operação de venda
                if (getSaleResponse && getSaleResponse.data && getSaleResponse.data.length !== 0) {
                    xml = getSaleResponse.data.xml
                    saleData = getSaleResponse.data
                    saleInfo = saleData
                    // Se um XML de nota fiscal foi recebido, imprime os comprovantes para o cliente
                    if (xml !== '') {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('cupom_recebido'), bold: false})
                        try {
                            let useDigitalPager = (Util.getLocalConfigs('useDigitalPager') && !Util.isOracle()) || false
                            if (useDigitalPager) {
                                await registerDigitalPager(saleData)
                            }
                            // desconto cashback
                            // aqui vai vir os dados necessarios para montagem do removePoints
                            await CashbackCampaingController.applyDiscount(saleData)
                            if (complementedPayment) {
                                let compPaymentData = IdentifiedConsumerController.getCompPaymentData()
                                // 1 = confirma transacao
                                if (!isTransire) {
                                    let flagStatusTef = localStorage.getItem('flagStatusTef')
                                    if (flagStatusTef) {
                                        flagStatusTef = JSON.parse(flagStatusTef)
                                        flagStatusTef.finishTef = 1
                                        flagStatusTef.saleCode = saleCode || null
                                        localStorage.setItem('flagStatusTef', JSON.stringify(flagStatusTef))
                                    }
                                    let resultFinishTransactionTEF = await PaymentController.finishTransactionTEF(1, compPaymentData.cupomFiscalSitef, compPaymentData.date, compPaymentData.hour, compPaymentData.value)
                                    if (!resultFinishTransactionTEF) {
                                        paymentOK = false
                                        throw new Error('Erro ao finalizar a transação TEF')
                                    }
                                }
                                paymentOK = true
                                CartController.clearbandeiraCartao()
                                CartController.clearDigitalWalletName()
                            }
                            if (Util.isTapMode()) {
                                await clearComanda(saveOrderResponse.saleCode)
                            }
                            paymentOK = true
                            return {
                                print: true,
                                printData: {
                                    saleData: saleData,
                                    xml: xml,
                                    paymentMethod: paymentMethod,
                                    paymentNumber: paymentNumber
                                }
                            }
                        } catch (error) {
                            paymentOK = false
                            localStorage.setItem('flagStatusTef', null)
                        }
                    }
                }

                if (getSaleResponse && getSaleResponse.error) {
                    Util.showInfoModal(getSaleResponse.message)
                    paymentOK = false
                } else if (xml === '') {
                    trataNotaFiscalNaoRecebida()
                    paymentOK = false
                }
            }
            if (closeOrderResponse && closeOrderResponse.error && !orderAlreadyClosed) {
                Util.showInfoModal(closeOrderResponse.message)
            }
        } else {
            Util.showInfoModal(LocaleController.getString('nao_foi_possivel_completar_venda'))
        }
    }

    if (!paymentOK) {
        await CashbackCampaingController.deleteReverve()
        if (saleCode !== null) {
            if (Util.isTapMode()) {
                // Cancela a pagamentos através da Odhen Interface se for TAP
                let cancelPaymentResponse = await cancelPaymentsTAP(saleCode)

                let errorCancelingAlreadyClosedOrder = cancelPaymentResponse && cancelPaymentResponse.error &&
                    cancelPaymentResponse.data && cancelPaymentResponse.data.errorCode === 1

                if (errorCancelingAlreadyClosedOrder) {
                    await cancelSale(null, saleCode)
                }
            } else {
                // Cancela a comanda/venda através da Odhen Interface se nao for TAP
                await cancelOrder(saleCode)
            }
        }

        if (complementedPayment) {
            let compPaymentData = IdentifiedConsumerController.getCompPaymentData()
            // 0 = não confirma transacao
            if (!isTransire) {
                let resultFinishTransactionTEF = await PaymentController.finishTransactionTEF(0, compPaymentData.cupomFiscalSitef, compPaymentData.date, compPaymentData.hour)
                if (!resultFinishTransactionTEF) {
                    throw new Error('Erro ao finalizar a transação TEF')
                }
                localStorage.setItem('flagStatusTef', null)
            }
            let message = `CP/DC - Transacao interrompida na rotina de salvarmento da venda com estorno do valor - PosCode: ${Util.getGeneralInfo()['posCode']}`
            if (saleCode != null) {
                message += ` - SaleCode: ${saleCode}`
            }
            Util.logComunication('Exception ', {}, message)
            CartController.clearbandeiraCartao()
            CartController.clearDigitalWalletName()
        }
    }

    // Embora este bloco verifique uma codição oposta à condição usada por um bloco if anterior (aqui se verifica
    // saveOrderResponse === null e lá se verifica saveOrderResponse !== null) esta chamada de showErrorScreen
    // NÃO PODE se transformar em um else do primeiro if, porque entre uma verificação e outra é preciso ter o bloco
    // acima que faz o cancelamento da transação.
    if (saveOrderResponse === null) {
        return Util.showErrorScreen(router, 'saveSaleError')
    }

    CartController.clearCartAndNavigateHome(router)
}

const doCashSale = async (paymentMethod, orderCPF, router) => {
    let cart = CartController.getCart()
    let saveOrderResponse = null
    let maxTries = 3
    let tries = 1
    let success = false
    let saveOrderErrorMessage = null

    do {
        // Salva o pedido, ainda pendente de pagamento, através da Odhen Interface.
        try {
            // O primeiro parametro seria o numero do pagamento, por isso é passada uma string vazia.
            saveOrderResponse = await saveOrder('', '', paymentMethod, cart, orderCPF)
        } catch (error) {
            let message = 'Erro ao salvar a venda na Odhen Interface'
            console.log(message)
            console.log(error)
            if (error.error) {
                saveOrderErrorMessage = error.message
            }
            Util.logComunication('Exception ', {}, message)
        }

        if (saveOrderResponse !== null && !saveOrderResponse.error) {
            success = true
        } else {
            tries++
        }
    } while (tries <= maxTries && !success)

    if (!success && saveOrderErrorMessage) {
        Util.showInfoModal(saveOrderErrorMessage)
    }

    if (saveOrderResponse !== null) {
        if (isValidResponse(saveOrderResponse)) {
            saleInfo = saveOrderResponse.data[0]
            eventModule.$emit('setSaleMessage', {text: LocaleController.getString('compra_concluida'), bold: false})
            let pagerId = saveOrderResponse.data[0].pagerId
            CartController.setPagerCode(pagerId)
            let saleData = {
                pagerId: pagerId
            }
            eventModule.$emit('setSaleMessage', {text: LocaleController.getString('aguarde_impressao'), bold: false})
            if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
            let printCouponResult = await PrinterController.printCoupon(saleData)
            if (!printCouponResult || (printCouponResult && printCouponResult.data && printCouponResult.data.error) || (printCouponResult && printCouponResult.error)) {
                console.log('Falha na impressora. Não foi possível imprimir o cupom do cliente.')
                return Util.showErrorScreen(router, 'printerError')
            }
            eventModule.$emit('setSaleMessage', {text: LocaleController.getString('pedido_impresso'), bold: false})
            eventModule.$emit('setSuccessSale', true)
            if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
        } else {
            let messageError = saveOrderResponse.error ? saveOrderResponse.message : LocaleController.getString('nao_foi_possivel_completar_venda')
            Util.showInfoModal(messageError)
        }
    } else {
        return Util.showErrorScreen(router, 'saveSaleError')
    }
    eventModule.$emit('hideLoadingSale')
    if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
    CartController.clearCartAndNavigateHome(router)
}

const doTefSale = async (paymentNumber, authHash, paymentMethod, orderCPF, router, paymentDate, paymentHour, cupomFiscalSitef, isTransire = false) => {
    let cart = CartController.getCart()
    let xml = '' // Recebe o XML da Receita
    let saleData = {} // Recebe os dados da venda da Odhen Interface
    let saveOrderResponse = null
    let maxTries = 3
    let tries = 1
    let success = false
    let confirmTEF = false
    let saleCode = null
    let savePaymentsError = false

    let saveOrderErrorMessage = null

    if (Util.isTapMode()) {
        saveOrderResponse = CartController.getMainComandaAgregada()
        let totalPriceStr = CartController.calculateTotalPrice()
        totalPriceStr = totalPriceStr.replace('R$', '').replace(',', '').replace('.', '').trim()
        let totalPrice = parseFloat(totalPriceStr) / 100

        let serviceTax = saveOrderResponse.serviceTax
        if (saveOrderResponse.serviceTax !== null) {
            await editServiceTax(saveOrderResponse.saleCode, serviceTax)
        }

        let digitalWalletName = CartController.getDigitalWalletName()
        let savePaymentsResponse = await savePaymentsTAP(
            saveOrderResponse.saleCode,
            paymentMethod,
            [{
                paymentCode: generatePaymentCode(paymentMethod),
                paymentName: '', // Descrição do pagamento
                value: totalPrice,
                nsu: paymentNumber, // Codigo do pagamento retornado pelo TEF. Em caso de pagamento em dinheiro, chega aqui como string vazia
                digitalWallet: digitalWalletName || null,
                authHash: authHash
            }],
            orderCPF
        )
        if (!savePaymentsResponse || (savePaymentsResponse && savePaymentsResponse.error)) {
            let messageError = savePaymentsResponse.error ? savePaymentsResponse.message : LocaleController.getString('nao_foi_possivel_completar_venda')
            savePaymentsError = true
            eventModule.$emit('setSaleMessage', {text: LocaleController.getString('nao_foi_possivel_completar_venda'), bold: false})
            Util.showInfoModal(messageError)
        }
    } else {
        do {
            // Salva o pedido através da Odhen Interface
            try {
                saveOrderResponse = await saveOrder(paymentNumber, authHash, paymentMethod, cart, orderCPF)
            } catch (error) {
                let message = 'Erro ao salvar a venda na Odhen Interface'
                console.log(message)
                console.log(error)
                if (error.error) {
                    saveOrderErrorMessage = error.message
                }
                Util.logComunication('Exception ', {}, message)
            }

            if (saveOrderResponse !== null && !saveOrderResponse.error) {
                success = true
            } else {
                tries++
            }
        } while (tries <= maxTries && !success)

        if (!success && saveOrderErrorMessage) {
            eventModule.$emit('setSaleMessage', {text: LocaleController.getString('falha_enviar_pedido'), bold: false})
            Util.showInfoModal(saveOrderErrorMessage)
        }
    }
    if (saveOrderResponse !== null && !savePaymentsError) {
        // Se a ordem foi salva corretamente, solicita à Odhen Interface o fechamento da comanda
        if (isValidResponse(saveOrderResponse)) {
            saveOrderResponse = saveOrderResponse.data ? saveOrderResponse.data[0] : saveOrderResponse

            eventModule.$emit('setSaleMessage', {text: `${LocaleController.getString('pedido')} ${saveOrderResponse.pagerId} ${LocaleController.getString('enviado_aguarde')}`, bold: false})
            CartController.setPagerCode(saveOrderResponse.pagerId)
            saleCode = saveOrderResponse.saleCode
            let statusFlagTef = {}
            try {
                /* Adiciona o saleCode ao statusFlagTef para se necessario cancelar o pagamento da comanda */
                statusFlagTef = localStorage.getItem('flagStatusTef')
                if (statusFlagTef) {
                    statusFlagTef = JSON.parse(statusFlagTef)
                    statusFlagTef.saleCode = saleCode
                    localStorage.setItem('flagStatusTef', JSON.stringify(statusFlagTef))
                }
            } catch (error) {
                statusFlagTef = {}
            }
            let closeOrderResponse = await closeOrder(saleCode)
            // Se o pedido de fechamento nao retornou erro, aguarda até que o fechamento seja finalizado e o XML
            // da nota fiscal seja recebido
            let orderAlreadyClosed = null
            let orderAlreadyFinsh = false
            let resultFinshOrder = null
            if (closeOrderByService) {
                orderAlreadyClosed = closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === true
                orderAlreadyFinsh = true
            } else {
                orderAlreadyClosed = !closeOrderResponse.error && closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === 'S'
                if (orderAlreadyClosed) {
                    resultFinshOrder = await finishOrder(closeOrderResponse.data)
                    if (resultFinshOrder && !resultFinshOrder.error) orderAlreadyFinsh = true
                }
            }
            // let orderAlreadyClosed = closeOrderResponse.data && closeOrderResponse.data.orderAlreadyClosed === true
            if ((!closeOrderResponse.error || orderAlreadyClosed) && orderAlreadyFinsh) {
                let getSaleResponse
                let numberOfTries = 0
                const maxTries = 120
                eventModule.$emit('setSaleMessage', {text: LocaleController.getString('aguardando_cupom'), bold: false})
                if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                do {
                    await delay(1)
                    getSaleResponse = null
                    try {
                        getSaleResponse = await getSale(saleCode)
                    } catch (error) {
                        getSaleResponse = { error: true, message: (error && error.message) || error.toString() }
                        console.log(getSaleResponse)
                    }
                    numberOfTries++
                    if (numberOfTries > 20) {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('demora_aguarde') + ' \n' + (maxTries - numberOfTries), bold: true})
                    }

                    if (getSaleResponse && getSaleResponse.error && numberOfTries === maxTries) {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('falha_cupom'), bold: false})
                        if (Util.isAndroidMode()) await waitForDOMUpdate.waitForDOMUpdate()
                        Util.showInfoModal(getSaleResponse.message)
                    }
                } while (
                    (getSaleResponse && getSaleResponse.data && getSaleResponse.data.length === 0 && getSaleResponse.error !== true && numberOfTries < maxTries) ||
                    (getSaleResponse === null && numberOfTries < maxTries)
                )
                // Se saiu do do-while porque recebeu a resposta esperada, continua a operação de venda
                if (getSaleResponse && getSaleResponse.data && getSaleResponse.data.length !== 0) {
                    xml = getSaleResponse.data.xml
                    saleData = getSaleResponse.data
                    saleInfo = saleData
                    // Se um XML de nota fiscal foi recebido, finaliza a rotina do TEF com confirmação e imprime os
                    // comprovantes para o cliente
                    if (xml !== '') {
                        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('cupom_recebido'), bold: false})
                        let useDigitalPager = (Util.getLocalConfigs('useDigitalPager') && !Util.isOracle()) || false
                        if (useDigitalPager) {
                            await registerDigitalPager(saleData)
                        }

                        try {
                            // aqui vai vir os dados necessarios para montagem do removePoints
                            await CashbackCampaingController.applyDiscount(saleData)
                            if (!isTransire) {
                                let flagStatusTef = localStorage.getItem('flagStatusTef')
                                if (flagStatusTef) {
                                    flagStatusTef = JSON.parse(flagStatusTef)
                                    flagStatusTef.finishTef = 1
                                    flagStatusTef.saleCode = saleCode || null
                                    localStorage.setItem('flagStatusTef', JSON.stringify(flagStatusTef))
                                }
                                let resultFinishTransactionTEF = await PaymentController.finishTransactionTEF(1, cupomFiscalSitef, paymentDate, paymentHour) // 1 = confirma transacao // Transire não tem confirmação
                                if (resultFinishTransactionTEF) {
                                    confirmTEF = true
                                    localStorage.setItem('flagStatusTef', null)
                                } else {
                                    throw new Error('Erro ao finalizar a transação TEF')
                                }
                            }
                            // confirmTEF = true
                            CartController.clearbandeiraCartao()
                            CartController.clearDigitalWalletName()
                            if (Util.isTapMode()) {
                                await clearComanda(saveOrderResponse.saleCode)
                            }
                            return {
                                print: true,
                                printData: {
                                    saleData: saleData,
                                    xml: xml,
                                    paymentMethod: paymentMethod,
                                    paymentNumber: paymentNumber
                                }
                            }
                        } catch (error) {
                            console.log(error)
                            confirmTEF = false
                            localStorage.setItem('flagStatusTef', null)
                        }
                    }
                }
                if (getSaleResponse && getSaleResponse.error) {
                    Util.showInfoModal(getSaleResponse.message)
                } else if (xml === '') {
                    trataNotaFiscalNaoRecebida()
                }
            }
            if (closeOrderResponse && closeOrderResponse.error && !orderAlreadyClosed) {
                Util.showInfoModal(closeOrderResponse.message)
            }
            if (resultFinshOrder && resultFinshOrder.error) {
                Util.showInfoModal(resultFinshOrder.message)
            }
        } else {
            let messageError = saveOrderResponse.error ? saveOrderResponse.message : LocaleController.getString('nao_foi_possivel_completar_venda')
            Util.showInfoModal(messageError)
        }
    }

    if (!confirmTEF) {
        // 0 = nao confirma transacao e estorna o valor
        if (!isTransire) {
            let resultFinishTransactionTEF = await PaymentController.finishTransactionTEF(0, cupomFiscalSitef, paymentDate, paymentHour)
            if (resultFinishTransactionTEF) {
                localStorage.setItem('flagStatusTef', null)
            }
        }
        let message = `Transacao interrompida na rotina de salvarmento da venda com estorno do valor - PosCode: ${Util.getGeneralInfo()['posCode']}`
        if (saleCode != null) {
            message += ` - SaleCode: ${saleCode}`
        }
        Util.logComunication('Exception ', {}, message)
        CartController.clearbandeiraCartao()
        CartController.clearDigitalWalletName()

        await CashbackCampaingController.deleteReverve()

        if (saleCode !== null) {
            if (Util.isTapMode()) {
                // Cancela a pagamentos através da Odhen Interface se for TAP
                let cancelPaymentResponse = await cancelPaymentsTAP(saleCode)
                let errorCancelingAlreadyClosedOrder = cancelPaymentResponse && cancelPaymentResponse.error &&
                    cancelPaymentResponse.data && cancelPaymentResponse.data.errorCode === 1

                if (errorCancelingAlreadyClosedOrder) {
                    await cancelSale(null, saleCode)
                }
            } else {
                // Cancela a comanda/venda através da Odhen Interface se nao for TAP
                eventModule.$emit('setSaleMessage', {text: `${LocaleController.getString('solicita_cancelamento')} ${saleCode}`, bold: false})
                let cancelResponse = await cancelOrder(saleCode)
                if (cancelResponse && !cancelResponse.error) {
                    eventModule.$emit('setSaleMessage', {text: `${LocaleController.getString('venda')} ${saleCode} ${LocaleController.getString('sera_cancelada')}`, bold: false})
                }
                await delay(5)
            }
        }
        Util.showInfoModal(LocaleController.getString('nao_foi_possivel_completar_venda'))
    }

    // Embora este bloco verifique uma codição oposta à condição usada por um bloco if anterior (aqui se verifica
    // saveOrderResponse === null e lá se verifica saveOrderResponse !== null) esta chamada de showErrorScreen
    // NÃO PODE se transformar em um else do primeiro if, porque entre uma verificação e outra é preciso ter o bloco
    // acima que faz o cancelamento da transação TEF.
    if (saveOrderResponse === null) {
        return Util.showErrorScreen(router, 'saveSaleError')
    }

    CartController.clearCartAndNavigateHome(router)
}

const isValidResponse = function (saveOrderResponse) {
    return (!saveOrderResponse.error && saveOrderResponse.data && saveOrderResponse.data[0] && saveOrderResponse.data[0].saleCode && saveOrderResponse.data[0].saleCode.length > 0) ||
        (saveOrderResponse.saleCode && saveOrderResponse.saleCode.length > 0)
}

async function registerDigitalPager (saleData) {
    const payload = {
        subsidiaryCode: saleData.subsidiaryCode,
        posCode: saleData.posCode,
        saleSeq: saleData.saleSeq
    }
    const result = await requesModule.postRequest(EVENT_REGISTER_PAGER, payload, 'parent')
        .then(r => r)
        .catch((e) => {
            Util.logComunication('Exception | registerDigitalPager', payload, result)
            Util.logComunication('Exception | registerDigitalPager', e.message)
            return false
        })
    if (!result || result.error || (!result.data || result.data.length === 0)) {
        Util.logComunication('Exception | registerDigitalPager', payload, result)
        return false
    }
    saleData.urlPager = result.data.url
    saleData.orderIdPager = result.data.orderId
    saleData.qrCodePager = result.data.qrCode
    Util.logComunication('registerDigitalPager | Pager digital registrado com sucesso', {}, result)
}

const getStatusTable = async function (nrComanda) {
    const generalInfo = Util.getGeneralInfo(false)
    const payload = {
        subsidiaryCode: generalInfo.subsidiaryCode || '',
        storeCode: generalInfo.storeCode || '',
        nrComanda: String(nrComanda),
        orderType: 'CMD'
    }
    return await requesModule.postRequest(EVENT_GET_STATUS_TABLE, payload, 'parent')
        .then(r => r)
        .catch(e => {
            Util.logComunication('Exception | getStatusTable', payload, e.message)
            return { error: true, message: 'Erro ao consultar status da comanda' }
        })
}

export default {
    performSale: async function (paymentNumber, authHash, paymentMethod, orderCPF, router, paymentDate, paymentHour, complementedPayment = false, cupomFiscalSitef = '', isTransire = false) {
        eventModule.$emit('showLoadingSale')
        eventModule.$emit('setSaleMessage', {text: LocaleController.getString('finalizando_compra'), bold: false})
        if (paymentMethod.IDTIPORECE === '9' || paymentMethod.IDTIPORECE === 'A') {
            return await doPersonalCreditSale(paymentMethod, orderCPF, router, complementedPayment, isTransire)
        } else if (paymentMethod.IDTIPORECE === '4') {
            // IDTIPORECE === '4' significa que a forma de pagamento escolhida foi dinheiro
            await doCashSale(paymentMethod, orderCPF, router)
        } else {
            return await doTefSale(paymentNumber, authHash, paymentMethod, orderCPF, router, paymentDate, paymentHour, cupomFiscalSitef, isTransire)
        }
    },
    cancelSale,
    editServiceTax,
    setPreOrderDate: (value) => {
        // seta o inicio da interação do usuario com o TAA
        preOrderDate = value
    },
    addPtoductsToComanda,
    getStatusTable,
    calculateSubTotal,
    getSaleInfo: function () {
        return saleInfo
    },
    setAddressData: (addressData) => {
        address = addressData
    },
    cancelPaymentsTAP,
    cancelOrder,
    clearComanda,
    openComanda: async function (nrComanda, personalQTD = 1, consumerName = '') {
        const generalInfo = Util.getGeneralInfo(false)

        const body = {
            subsidiaryCode: generalInfo.subsidiaryCode || '',
            storeCode: generalInfo.storeCode || '',
            orderType: 'CMD',
            nrComanda: String(nrComanda),
            personalQTD: String(personalQTD)
        }

        if (consumerName && consumerName.trim()) {
            body.consumer = { name: consumerName.trim() }
        }

        return await requesModule.postRequest('sale/openTable', body, 'parent')
            .then(r => r)
            .catch(e => {
                Util.logComunication('Exception | openComanda', body, e.message)
                return { error: true, message: 'Erro ao abrir comanda' }
            })
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/SaleController.js